import {Tab, Tabs} from "@heroui/tabs";
import DirectOfferVariantItem from "../DirectOfferVariantItem";
import {DirectOffer} from "../../../types";

export default function BottomWidgetPreview ({ directOffer } : { directOffer: DirectOffer }) {

    return (
        <div className={'bg-white border rounded-lg p-8 flex flex-col items-center justify-center inset-shadow-black inset-shadow-lg'}>
            <Tabs aria-label="Variants">
                {
                    directOffer.variants.map((variant, index) => (
                        <Tab title={`Variante ${index + 1}`} key={`tab-${index}`}>
                            <DirectOfferVariantItem variant={variant} />
                        </Tab>
                    ))
                }
            </Tabs>
        </div>
    )

}
